import PersonCareTeam from './PersonCareTeam';

export default PersonCareTeam;
